import cls from "./UserInitials.module.scss"
import { memo } from "react"
import { Title } from "src/shared/ui/title/Title"

interface IUserInitials {
  onClick: () => void
  text: string
}

export const UserInitials = memo(({ onClick, text }: IUserInitials) => (
  <button className={cls.button} type="button" onClick={onClick}>
    <Title size="s">{text}</Title>
  </button>
))
